<template>
    <aside class="main-sidebar sidebar-light-danger elevation-4" ref="mainsidebar">
    <!-- Brand Logo -->
    <!-- <router-link to="/" class="brand-link">
      <img src="../assets/image/artrade-logo.png" alt="Artrade Logo" class="brand-image elevation-3">
      <span class="brand-text font-weight-light">Art of Trading</span>
    </router-link> -->

		<!-- Sidebar -->
		<div class="sidebar" id="sidebarnav" ref="datasidebar">
			<!-- Sidebar user panel (optional) -->
			<!-- <pre>{{isSidebarCollapsed}}</pre> -->
			<div class="user-panel d-flex align-items-center">
				<div class="image">
					<a class="navbar-brand" href="">
						<div class="d-flex">
							<img src="../assets/image/logo-artrade2.png" style="width:150px;" alt="">
							<!-- <div class="d-flex flex-column">
								<p class="pt-2 bold mb-0">Ar<span class="text-danger">T</span>rade</p>
								<h5 class="text-center text-danger bold" style="font-size: 16px; margin-top: -5px;">Smart Solution</h5>
							</div> -->
						</div>
					</a>
				</div>
				<div class="image2">
					<a class="navbar-brand" href="">
						<div class="d-flex">
							<img src="../assets/logo2.png" style="width:100%;" alt="">
							<!-- <div class="d-flex flex-column">
								<p class="pt-2 bold mb-0">Ar<span class="text-danger">T</span>rade</p>
								<h5 class="text-center text-danger bold" style="font-size: 16px; margin-top: -5px;">Smart Solution</h5>
							</div> -->
						</div>
					</a>
				</div>
				<!-- <div class="brand-text">
					<h4>Art of Trading</h4>
					<p>Secure, Easy, Fast and Profitable</p>
				</div> -->
			</div>
		<sidebar-menu></sidebar-menu>
		</div>
		<!-- /.sidebar -->
	</aside>
</template>
<script>
import SidebarMenu from '../layouts/SidebarMenu.vue'
export default {
	name: 'Sidebar',
	components:{
		SidebarMenu
	},
}
</script>
<style scoped>
.navbar-brand p{
	font-weight: 800;
	font-size: 1.5rem;
}
.navbar-brand small{
	font-weight: 700;
	font-size: 0.75rem !important;
}


.main-sidebar .image{
	display: block;
}
.main-sidebar .image2{
	display: none;
}
.image2 .navbar-brand{
	margin: 0px !important;
}
@media (min-width: 992px){
	.sidebar-mini.sidebar-collapse .main-sidebar .image{
		display: none !important;
	}
	.sidebar-mini.sidebar-collapse .main-sidebar .image2{
		display: block !important;
	}
}
</style>
<style>
.main-sidebar{
	background: white !important;
	box-shadow: 5px 0 40px rgba(0, 0, 0, 0.1) !important;
}
.user-panel{
	padding: 20px 0;
}
.user-panel .image img{
	width: 40%;
	height: auto;
}
.user-panel .brand-text{
	margin-left: 6px;
}
.user-panel .brand-text h4{
	font-weight: 800;
	color: var(--dark-grey);
	font-size: 17pt;
	margin: 0;
}
.user-panel .brand-text p{
	font-weight: 400;
	color: var(--dark-grey);
	font-size: 7pt;
	margin: 0;
}
@media(max-width: 767.98px){
	/* .main-sidebar{
		background: white !important;
	} */
}
</style>